export const removeUndefinedFields = (
  object: Record<string, unknown>,
): Record<string, unknown> => {
  const objectCopy = { ...object };

  Object.keys(objectCopy).forEach(key => {
    if (objectCopy[key] === undefined || objectCopy[key] === null) {
      delete objectCopy[key];
    }
  });

  return objectCopy;
};
